<template>
  <div
    class="shadow-sm"
    style="border: 1px solid #E0E0E0; border-radius: 0.45rem;"
  >
    <div class="subHeader">
      <div class="row">
        <div
          v-if="titleType === 'text'"
          class="col-6"
        >
          {{ cardTitle }}
        </div>
        <a
          v-if="titleType === 'link' "
          class="col-6"
          style="color: black"
          :target="linkConfig?.target"
          :href="linkConfig?.url"
        >
          {{ cardTitle }}
        </a>
      </div>
    </div>

    <slot name="thead" />
    <slot name="row" />

    <div
      class="card rs-custom-card border-top border-bottom-0 border-left-0 border-right-0 rounded-0"
      style="overflow: hidden; border-color: grey"
    >
      <div
        class="card-header bg-white p-0 mr-3"
      >
        <button
          type="button"
          class="btn btn-secondary btn-block"
          @click="onExpandToggle()"
        >
          <div
            v-if="!isExpand"
            class="flex-right row m-0"
          >
            <span style="font-size: 14px">Show More</span>
            <div class="col p-0 ml-2 flex-grow-0">
              <i
                class="far fa-chevron-down"
              />
            </div>
          </div>
          <div
            v-if="isExpand"
            class="flex-right row m-0"
          >
            <span style="font-size: 14px">Show Less</span>
            <div class="col p-0 ml-2 flex-grow-0">
              <i
                class="far fa-chevron-up"
              />
            </div>
          </div>
        </button>
      </div>

      <div
        v-if="isExpand"
        style="border-radius: 0.45rem;"
      >
        <RsDataTableTemp
          :id="tableProps?.id as string"
          :fields="tableProps?.fields"
          :no-filter="tableProps?.noFilter"
          :data-list="list || []"
          :data-meta="undefined"
          :is-loading="!list"
          :row-selectable="false"
          :log-available-events="true"
          :show-checkboxes="false"
          :has-details-view="false"
          :has-export="tableProps?.hasExport"
          :has-no-border="true"
        >
          <template #filterBeforeSearchSlot>
            <slot name="filterBeforeSearchSlot" />
          </template>

          <template #filterLeft>
            <slot name="filterLeft" />
          </template>

          <template #filterRight>
            <slot name="filterRight" />
          </template>

          <template #filterEnd>
            <slot name="filterEnd" />
          </template>
        </RsDataTableTemp>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IDataTableFieldConfig } from '@/shared';

type TTableProps = {
  id: string,
  fields: IDataTableFieldConfig[],
  hasExport: boolean,
  noFilter: boolean,
};

type TLinkConfig = { target: string, url: string };

export default defineComponent({
  props: {
    list: Array as PropType<Record<string, any>[] | undefined>,
    tableProps: Object as PropType<TTableProps>,
    cardTitle: String,
    titleType: {
      type: String as PropType<'link' | 'text'>,
      default: 'text',
    },
    linkConfig: Object as PropType<TLinkConfig>,
  },

  data() {
    return {
      isExpand: false as boolean,
    };
  },

  methods: {
    onExpandToggle() {
      this.isExpand = !this.isExpand;
      this.$emit('on-expand-toggle', this.isExpand);
      return this.isExpand;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
$table-border: 1px solid rgba($tertiary-gray, 0.6);

.table {
  width: 100%;
  margin-bottom: 0;
  color: #212529;
  background-color: white;
  border: 1px $border-color solid;
}

.flex-right {
  justify-content: end;
  color: $primary-color;
}

.subHeader{
  padding: 0.5rem;
  background-color: #E0E0E0;
  border: solid 1px $border-color;
  border-radius: 0.45rem 0.45rem 0 0;
  font-weight: bold;
  .secondaryHeader{
    text-align: end;
    p {
      margin: 0;
      font-size: 14px;
    }
  }
}

</style>
